import React from 'react'
import { useStyles } from '../style'
import { NOT_SELECTED, NOT_SELECTED_MD } from '../constant'
import { Hidden } from '@material-ui/core'

function NotSelected() {
  const classes = useStyles()
  return (
    <div className={classes.notSelected}>
      <Hidden smDown>
        {NOT_SELECTED}
      </Hidden>
      <Hidden mdUp>
        {NOT_SELECTED_MD}
      </Hidden>
    </div>
  )
}

export default NotSelected